import React from "react";
import { format } from 'date-fns';
import { toast } from 'react-toastify';
import { 
  checkCurrentOrBeforeDate, 
  getUpdatedSelection,
  checkEditPermission,
  isFirefox
} from "../../../Utils/helper";
import { 
  buildCellData, 
  handleCellContextMenu, 
  cellHasRemarks, 
  getCellDataAttributes 
} from '../../../Utils/cellRemarkHelper';

const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;

export const renderPrepackProductGroupSection = (salesColumn, salesColumnsWithData, formattedDate, inoutData, isEditing, updateId, updateDate, updateProduct, updateValue, setIsEditing, setUpdateValue, setUpdateId, setUpdateDate, setUpdateProduct, updateReserveData, showGroupData, selectedGroupProducts, setTooltipPosition, nextDate,  setLabelData,  setSubGroup, setProductName, setLabelDate, setProductGroupLabelModal, setReserveModalUpdateData, inputRefs, flatInputIndex, loader, setGroupProductIds, setModalInputDisabled, setSubGroupName, rolesData, rowIndex, columnCounter, selectedCell, setSelectedCell, selectedCellsForSum, setSelectedCellsForSum, inputValues,  setModalConvertOut, setSelectedManualConvertOutRawProductId, setSelectedManualConvertOutFinishedProductId, setSelectedManualConvertOutDate, checkEditPermission, setContextMenu, setSelectedCellData, cellRemarks, onEditActualStock, hiddenReserveGroups) => {
  const productGroupId = salesColumn.data.productGroupkey;
  const customerGroups = inoutData?.sectionReserves?.productGroup?.data?.[productGroupId] || {};
  const groupProductIds = inoutData.sections?.data?.find(item => item.group_key === productGroupId)?.product_ids?.split(',') || [];
  let reserveUpdateProductIds = [];
  if (salesColumn?.data?.prepackProductType == 0) { //only raw
    reserveUpdateProductIds = [...Object.keys(salesColumn?.data?.finishedProductCodes)];
  } else if (salesColumn?.data?.prepackProductType == 1) { //only finished
    reserveUpdateProductIds = [...groupProductIds];
  }
  else if (salesColumn?.data?.prepackProductType == 2) { //both
    reserveUpdateProductIds = [...groupProductIds, ...Object.keys(salesColumn?.data?.finishedProductCodes)];
  }
  
  const matchingProductGroup = salesColumnsWithData.find(group => group.productGroupKey === productGroupId);
  const convertOutsObject = inoutData?.convertOuts?.productGroup?.data?.[productGroupId]?.[formattedDate] || {} ;
  const convertOutsHistoryObject = inoutData?.convertOuts?.productGroup?.history?.[productGroupId]?.[formattedDate] || {};
  const firstFinishProductId = Object.keys(salesColumn?.data?.finishedProductCodes)?.[0];

  const totalConvertOutQuantity = convertOutsObject 
    ? Object.values(convertOutsObject).reduce((sum, item) => sum + (item || 0), 0)
    : '';
  const displayConvertInQuantity = inoutData?.convertIns?.productGroup?.data?.[productGroupId]?.[formattedDate] || '';


  const arrivalDataForDate = matchingProductGroup?.arrivalData?.[formattedDate] || [];
  const totalArrivalQuantity = arrivalDataForDate.reduce((sum, item) => sum + (item?.arrival || 0), 0);
  const arrivalHistoryValue = matchingProductGroup?.arrivalHistory?.[formattedDate]?.history;

  const displayArrivalQuantity = arrivalHistoryValue !== undefined
    ? `${arrivalHistoryValue} -> ${totalArrivalQuantity}`
    : totalArrivalQuantity > 0 ? totalArrivalQuantity : '';

  const inventoryForDate = Object.values(matchingProductGroup?.inventoryData?.data || {}).find(
    data => data?.date === nextDate
  );
  const estimatedStock = inventoryForDate?.estimated || 0;
  const actualStock = inventoryForDate?.actual || 0;
  const inventoryStatus = inventoryForDate?.status;
  const isCurrentOrBeforeDate = checkCurrentOrBeforeDate(nextDate);
  
  return (
    <>
      {/* //arrival qty cell block */}
      { salesColumnsWithData?.length > 0 && (() => {
        const thisCol = columnCounter.value++;
        const key = `${rowIndex}-${thisCol}`;
        const isSelected = selectedCellsForSum[key] !== undefined;

        const handleClick = () => {
          setSelectedCell({ row: rowIndex, col: thisCol });

          if (displayArrivalQuantity == '') {
            return;
          }
          const newSelection = getUpdatedSelection(
            selectedCellsForSum,
            rowIndex,
            thisCol,
            Number(totalArrivalQuantity) || 0
          );
          setSelectedCellsForSum(newSelection);
        };
        
        const arrivalQtyGroupCellData = buildCellData({
          cellType: 'arrival_qty',
          date: formattedDate,
          module: 'prepack-inout',
          productGroupId: productGroupId,
          finishedProductId: firstFinishProductId,
          productGroupName: salesColumn.data.productGroupId,
        });
        const hasRemarksArrivalQtyGroup = cellHasRemarks(arrivalQtyGroupCellData, cellRemarks);
        
        return (
          <td 
            onClick={handleClick}
            onContextMenu={(e) => {
              handleCellContextMenu(e, arrivalQtyGroupCellData, setContextMenu, setSelectedCellData);
            }}
            {...getCellDataAttributes(arrivalQtyGroupCellData)}
            className={`arrival-bg arival-qty-ui fw-bold remark-enabled-cell ${hasRemarksArrivalQtyGroup ? 'cell-with-remark' : ''} ${displayArrivalQuantity !== '' ? 'show-sum-checkbox' : ''} ${isSelected ? "selected-for-sum" : ""}  ${selectedCell.row === rowIndex || selectedCell.col === thisCol ? "highlight-border" : ""}`} key={`${productGroupId}-${arrivalDataForDate?.id}`}>
           {/* {displayArrivalQuantity} */}
            <div className="flex ">
              {displayArrivalQuantity !== '' && <div className="grouping">
                <label className="checbox-cs relative cursor-pointer">
                  <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={(e) => {
                      e.stopPropagation();
                      handleClick();
                    }}
                    className="cursor-pointer absolute opacity-0 w-0 h-0"
                  />
                  <span className="checkmark" onClick={(e) => e.stopPropagation()} ></span>
                </label>{" "}
                <span className="ml-1">{displayArrivalQuantity}</span>
              </div>}
            </div>
          </td>
        );
      })()}
      <React.Fragment key={`product-group-${productGroupId}`}>
        {/* //convert in block */}
        {(salesColumn?.data?.prepackProductType == 1 || salesColumn?.data?.prepackProductType == 2) && (() => {
          const thisCol = columnCounter.value++;
          const key = `${rowIndex}-${thisCol}`;
          const isSelected = selectedCellsForSum[key] !== undefined;
          const handleClick = () => {
            setSelectedCell({ row: rowIndex, col: thisCol });

            if (displayConvertInQuantity == '') {
              return;
            }
            const newSelection = getUpdatedSelection(
              selectedCellsForSum,
              rowIndex,
              thisCol,
              Number(displayConvertInQuantity) || 0
            );
            setSelectedCellsForSum(newSelection);
          };
          
          const convertInGroupCellData = buildCellData({
            cellType: 'convert_in',
            date: formattedDate,
            module: 'prepack-inout',
            productGroupId: productGroupId,
            finishedProductId: groupProductIds[0] || firstFinishProductId,
            productGroupName: salesColumn.data.productGroupId,
          });
          const hasRemarksConvertInGroup = cellHasRemarks(convertInGroupCellData, cellRemarks);
          
          return (
            <td 
              onClick={handleClick} 
              onContextMenu={(e) => {
                handleCellContextMenu(e, convertInGroupCellData, setContextMenu, setSelectedCellData);
              }}
              {...getCellDataAttributes(convertInGroupCellData)}
              className={`arrival-bg arival-qty-ui fw-bold remark-enabled-cell ${hasRemarksConvertInGroup ? 'cell-with-remark' : ''} ${displayConvertInQuantity !== '' ? 'show-sum-checkbox' : ''} ${isSelected ? "selected-for-sum" : ""}  ${selectedCell.row === rowIndex || selectedCell.col === thisCol ? "highlight-border" : ""}`} key={`${productGroupId}-${arrivalDataForDate?.id}`}>
              <div className="flex ">
                {displayConvertInQuantity !== '' && <div className="grouping">
                  <label className="checbox-cs relative cursor-pointer">
                    <input
                      type="checkbox"
                      checked={isSelected}
                      onChange={(e) => {
                        e.stopPropagation();
                        handleClick();
                      }}
                      className="cursor-pointer absolute opacity-0 w-0 h-0"
                    />
                    <span className="checkmark" onClick={(e) => e.stopPropagation()} ></span>
                  </label>{" "}
                  <span className="ml-1">{displayConvertInQuantity}</span>
                </div>}
              </div>
            </td>
          );
        })()}
        {/* //reserve data block */}
        {customerGroups && typeof customerGroups === 'object' &&
          Object.entries(customerGroups).flatMap(([customerGroupLabel, customerSubGroups]) => {
            if (!customerSubGroups || typeof customerSubGroups !== 'object') return [];
            return Object.entries(customerSubGroups).map(([customerSubGroupId, dates]) => {
              if (!dates || typeof dates !== 'object') return null;
              const dateKey = Object.keys(dates)[0];
              const firstDateEntry = dates[dateKey]?.[0];
              const customerSubGroupName = firstDateEntry?.customer_sub_group_name || 'N/A';
              const subGroupNameid = firstDateEntry?.customer_sub_group_id || 'N/A';
              const groupName = firstDateEntry?.customer_group_id || 'N/A';
              const productName = firstDateEntry?.product_id || 'N/A';
              const productGroupName = firstDateEntry?.product_group_id || 'N/A';
              const combinedKey = `${subGroupNameid}-${groupName}-${productName}-${productGroupId}`;
              const unitPrice = (inoutData?.sectionReserves?.productGroup?.data?.[productGroupId]?.[customerGroupLabel]?.[customerSubGroupId]?.[nextDate] || [])
                .map(item => item.unit_price)
                .filter(item => item !== undefined && item !== null)
                .join(', ');
              const historyValue = inoutData?.sectionReserves?.productGroup?.history?.[productGroupId]?.[customerGroupLabel]?.[customerSubGroupId]?.[nextDate]?.history;
              const allReservations = dates[nextDate] || [];

              let quantityObjects = [];
              if (Array.isArray(allReservations)) {
                quantityObjects.push(...allReservations.filter(res =>
                  res.product_group_id === productGroupId &&
                  res.customer_sub_group_id === subGroupNameid
                ));
              } 

              const checkCustomerGroup = inoutData?.customerGroupsV2?.[firstDateEntry?.customer_group_label]?.[subGroupNameid];

              const getFilteredDataByDate = (flatData, targetDate, label) => {
                const resultMap = new Map();
                if (!Array.isArray(flatData)) return [];

                for (const entry of flatData) {
                  if (entry.date !== targetDate) continue;
                  if (label && entry.customer_group_label !== label) continue;

                  const groupId = entry.customer_group_id;
                  const groupList = inoutData?.customerGroups?.[entry.customer_group_label];
                  const customerGroupObject = Array.isArray(groupList)
                    ? groupList.find(group => group.id === groupId) : null;
                  if (!resultMap.has(groupId)) {
                    resultMap.set(groupId, {
                      groupLabel: [{
                        id: groupId,
                        label: entry.customer_group_label,
                        name: customerGroupObject?.name,
                        code: customerGroupObject?.code
                      }],
                      subGroups: []
                    });
                  }

                  const group = resultMap.get(groupId);
                  const alreadyExists = group.subGroups.some(
                    (e) => e.id === entry.id && e.product_id === entry.product_id
                  );

                  if (!alreadyExists) {
                    group.subGroups.push(entry);
                  }
                }

                const resultArray = [];
                if (checkCustomerGroup && checkCustomerGroup.length > 0) {
                  for (const group of checkCustomerGroup || []) {
                    const groupId = group.customer_group_id;
                    const mapped = resultMap.get(groupId) || {
                      groupLabel: [group],
                      subGroups: []
                    };
                    mapped.groupLabel = [group];
                    resultArray.push({
                      groupLabel: mapped.groupLabel,
                      subGroups: mapped.subGroups
                    });
                  }
                } else {
                  for (const [groupId, mapped] of resultMap.entries()) {
                    resultArray.push({
                      groupLabel: mapped.groupLabel,
                      subGroups: mapped.subGroups
                    });
                  }
                }
                return resultArray;
              };


              const filteredData = getFilteredDataByDate(quantityObjects, nextDate, firstDateEntry?.customer_group_label);

              const quantity = quantityObjects.length === 0
                ? {
                  customer_group_name: groupName,
                  customer_sub_group_name: subGroupNameid,
                  product_name: productName,
                  date: nextDate,
                  product_group_name: productGroupId,
                  type: 'productGroup'
                }
                : quantityObjects;

              let quantityValue = '';
              let quantityId = null;
              let currentValue = 0;

              if (quantityObjects.length > 0) {
                const totalQuantity = quantityObjects.reduce((sum, q) => sum + (q?.quantity || 0), 0);
                const hasImported = quantityObjects.some(q => q?.is_imported === 1);
                quantityValue = (totalQuantity === undefined || totalQuantity === null)
                  ? ''
                  : historyValue !== undefined
                    ? `${historyValue} -> ${totalQuantity}`
                    : totalQuantity > 0
                      ? hasImported ? `0 -> ${totalQuantity}` : totalQuantity
                      : totalQuantity;
                currentValue = totalQuantity;
                quantityId = quantityObjects[0]?.id;
              } else {
                const qty = quantityObjects.quantity;
                quantityValue = (qty === undefined || qty === null)
                  ? ''
                  : historyValue !== undefined
                    ? `${historyValue} -> ${qty}`
                    : qty > 0
                      ? `0 -> ${qty}`
                      : qty;
              }
              const currentInputIndex = flatInputIndex.current++;
              const shouldOpenModal = (checkCustomerGroup?.length || 0) > 1 || (quantityObjects?.length || 0) > 1;
              if (!(Object.keys(customerGroups).length !== 0)) return null;
              const thisCol = columnCounter.value++;

              // If reserve is hidden for this group, render invisible placeholder
              const isReserveHidden = hiddenReserveGroups?.has(productGroupId);
              if (isReserveHidden) {
                return <td key={`sales-hidden-${combinedKey}`} style={{ display: 'none' }} />;
              }
              
              const reserveGroupCellData = buildCellData({
                cellType: 'sales_reserve',
                date: nextDate,
                module: 'prepack-inout',
                productGroupId: productGroupId,
                finishedProductId:(salesColumn.data?.prepackProductType == 0 || salesColumn.data?.prepackProductType == 2) ? firstFinishProductId : groupProductIds[0],
                customerGroupId: groupName,
                customerSubGroupId: subGroupNameid,
                reserveLabel: customerGroupLabel,
                productGroupName: salesColumn.data.productGroupId,
              });
              const hasRemarksReserveGroup = cellHasRemarks(reserveGroupCellData, cellRemarks);
              
              return (
                <td 
                key={`sales-${combinedKey}`} 
                onClick={() => {
                  setSelectedCell({ row: rowIndex, col: thisCol });
                }}
                  onContextMenu={(e) => {
                    handleCellContextMenu(e, reserveGroupCellData, setContextMenu, setSelectedCellData);
                  }}
                  {...getCellDataAttributes(reserveGroupCellData)}
                  className={`sales-bg remark-enabled-cell ${hasRemarksReserveGroup ? 'cell-with-remark' : ''} ${columnCounter} ${selectedCell.row === rowIndex || selectedCell.col === thisCol ? "highlight-border" : ""}`}
                  onMouseEnter={(e) => {
                    const hasUnitPrice = unitPrice && unitPrice !== '';
                    const hasPromotion = Array.isArray(quantityObjects)
                      ? quantityObjects[0]?.promotion_type !== undefined && quantityObjects[0]?.promotion_type !== null
                      : quantityObjects?.promotion_type !== undefined && quantityObjects?.promotion_type !== null;

                    if (hasUnitPrice || hasPromotion) {
                      const rect = e.currentTarget.getBoundingClientRect();
                      const promotionType = hasPromotion ? {
                        promotion_type: Array.isArray(quantityObjects)
                          ? quantityObjects[0]?.promotion_type
                          : quantityObjects?.promotion_type,
                        product_name: firstDateEntry?.product_name_tc,
                        product_date: nextDate
                      } : null;

                      setTooltipPosition({
                        visible: true,
                        x: rect.right + 10,
                        y: rect.top,
                        unitPriceValue: hasUnitPrice ? unitPrice : null,
                        promotionType: promotionType,
                        content: promotionType
                      });
                    }
                  }}
                  onMouseLeave={() => {
                    setTooltipPosition({
                      visible: false,
                      promotionType: null,
                      unitPriceValue: null,
                      content: null,
                      x: 0,
                      y: 0
                    });
                  }}
                >
                  <input
                    ref={(el) => {
                      if (el) inputRefs.current.push(el);
                    }}
                    data-index={currentInputIndex}
                    tabIndex={currentInputIndex}
                    type='text'
                    className={`inout-tab ${(Array.isArray(quantityObjects)
                      ? quantityObjects[0]?.promotion_type !== undefined && quantityObjects[0]?.promotion_type !== null
                      : quantityObjects?.promotion_type !== undefined && quantityObjects?.promotion_type !== null
                    ) ? 'highlight' : ''
                      } ${(Array.isArray(quantityObjects) ? quantityObjects.some(q => q.is_batch_updated) : quantityObjects.is_batch_updated) ? 'text-batch-updated' : ''}`}
                    value={(() => {
                      const inputKey = `${rowIndex}-${thisCol}`;
                      const inputValue = inputValues[inputKey];
                      const isCurrentlyEditing = isEditing === quantityValue && updateId === quantityId && updateDate === nextDate && updateProduct === combinedKey;
                      
                      let finalValue = inputValue !== undefined
                        ? inputValue
                        : isCurrentlyEditing
                          ? updateValue
                          : quantityValue;
                      
                      if (isCurrentlyEditing && typeof finalValue === 'string' && finalValue.includes('->')) {
                        const parts = finalValue.split('->');
                        finalValue = parts[parts.length - 1].trim();
                      }
                      
                      return finalValue;
                    })()}
                    onClick={(e) => {
                      if (!checkEditPermission(rolesData?.permissions, 'direct_in_out')) {
                        return;
                      }
                      setIsEditing(quantityValue);
                      const existingValue = inputValues[`${rowIndex}-${thisCol}`];
                      let valueToSet = existingValue !== undefined ? existingValue : (currentValue > 0 ? currentValue : '');
                      
                      if (typeof valueToSet === 'string' && valueToSet.includes('->')) {
                        const parts = valueToSet.split('->');
                        valueToSet = parts[parts.length - 1].trim();
                      }
                      
                      setUpdateValue(valueToSet);
                      setUpdateId(quantityId);
                      setUpdateDate(nextDate);
                      setUpdateProduct(combinedKey);
                      setGroupProductIds(reserveUpdateProductIds)

                      if (shouldOpenModal) {
                        const input = e.target;
                        input.blur();
                        setProductGroupLabelModal(true); setLabelData(filteredData); setSubGroup(subGroupNameid); setSubGroupName(customerSubGroupName); setProductName(productGroupName); setLabelDate(nextDate); setReserveModalUpdateData(quantityObjects); setModalInputDisabled(isCurrentOrBeforeDate);
                      }
                    }}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      setUpdateValue(newValue);
                      if (quantityObjects?.length <= 1 || quantityObjects == 0) {
                        updateReserveData(
                          quantity?.length > 0 ? quantity[0] : quantity,
                          newValue,
                          `${rowIndex}-${thisCol}`
                        );
                      }
                    }}
                    // onMouseEnter={(e) => {
                    //   const hasPromotion =
                    //     Array.isArray(quantityObjects)
                    //       ? quantityObjects[0]?.promotion_type != null
                    //       : quantityObjects?.promotion_type != null;

                    //   if (hasPromotion) {
                    //     const rect = e.target.getBoundingClientRect();
                    //     const promotionType = {
                    //       promotion_type: Array.isArray(quantityObjects)
                    //         ? quantityObjects[0]?.promotion_type
                    //         : quantityObjects?.promotion_type,
                    //       product_name: firstDateEntry?.product_name_tc,
                    //       product_date: formattedDate
                    //     };

                    //     setTooltipPosition({
                    //       visible: true,
                    //       x: rect.right + 10,
                    //       y: rect.top,
                    //       content: promotionType,
                    //       promotionType: promotionType
                    //     });
                    //   }
                    // }}
                    // onMouseLeave={() => {
                    //   setTooltipPosition(prev => ({ ...prev, visible: false }));
                    // }}
                    onKeyDown={(e) => {
                      const allowedKeys = [
                        '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
                        'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight',
                        'Delete', 'Home', 'End'
                      ];
                      const ctrlKey = isMac ? e.metaKey : e.ctrlKey;
                      if (ctrlKey && ['c', 'v', 'x', 'a'].includes(e.key.toLowerCase())) {
                        return; // Allow copy/paste/cut/select-all
                      }
                      if (!allowedKeys.includes(e.key)) {
                        e.preventDefault();
                      }
                      if (e.key === 'Tab') {
                        e.preventDefault();

                        const currentIndex = inputRefs.current.findIndex(ref => ref === e.target);
                        if (shouldOpenModal) {
                          setProductGroupLabelModal(true);
                          setLabelData(filteredData);
                          setSubGroup(subGroupNameid);
                          setSubGroupName(customerSubGroupName);
                          setProductName(productGroupName);
                          setLabelDate(nextDate);
                          setReserveModalUpdateData(quantityObjects);
                          setModalInputDisabled(isCurrentOrBeforeDate);
                        } else {
                          setTimeout(() => {
                            const nextInput = inputRefs.current[currentIndex + 1];
                            if (nextInput) { nextInput.focus(); nextInput.click() }
                          }, 0);
                        }
                      }
                    }}
                    pattern="[0-9]*"
                    inputMode="numeric"
                    disabled={loader || (isCurrentOrBeforeDate && !shouldOpenModal) || !checkEditPermission(rolesData?.permissions, 'direct_in_out')}
                    style={(loader || (isCurrentOrBeforeDate && !shouldOpenModal) || !checkEditPermission(rolesData?.permissions, 'direct_in_out')) ? { cursor: 'not-allowed', pointerEvents: isFirefox ? 'none' : 'auto' } : {}}
                  />
                </td>
              );
            });
          })}
        {/* //convert out */}
        {/* {(salesColumn?.data?.prepackProductType == 0 || salesColumn?.data?.prepackProductType == 2) && (() => { */}
        {(salesColumn?.data?.prepackProductType == 0 || salesColumn?.data?.prepackProductType == 2) && typeof salesColumn?.data?.finishedProductCodes === 'object' && Object.entries(salesColumn?.data?.finishedProductCodes).map(([finish_pid, finish_code]) => {
          return (()=>{

          const thisCol = columnCounter.value++;
          const key = `${rowIndex}-${thisCol}`;
          const convertOutQuantity = convertOutsObject[finish_pid] ?? '';
          const convertOutHistoryQuantity = convertOutsHistoryObject[finish_pid] ?? '';
          // const convertOutInputValue = convertOutInputs?.[key];
          // const displayConvertOutQuantity = convertOutInputValue ?? convertOutQuantity ?? '';
          // const isThisCellSelected = selectedCell.row === rowIndex && selectedCell.col === thisCol;
          const displayConvertOutQuantity = convertOutHistoryQuantity !== '' ? `${convertOutHistoryQuantity} -> ${convertOutQuantity}` : convertOutQuantity;
          const convertOutPrepackType = salesColumn?.data?.finishedProductPrepackTypes?.[finish_pid] || '';
          
          // Check if date is outside special period range for Type C
          const specialPeriod = salesColumn?.data?.finishedProductSpecialPeriods?.[finish_pid];
          
          const fiveDaysAgo = new Date();
          fiveDaysAgo.setDate(fiveDaysAgo.getDate() - 5);
          const formattedFiveDaysAgo = format(fiveDaysAgo, 'yyyy-MM-dd');

          const isTypeC = convertOutPrepackType === 'C' || convertOutPrepackType?.includes('C');
          const isOutsideSpecialRange = isTypeC && specialPeriod && (nextDate < specialPeriod.from || nextDate > specialPeriod.to);
          const isOlderThanFiveDays = isTypeC && nextDate <= formattedFiveDaysAgo;
          const isOutsideSpecialPeriod = isOutsideSpecialRange || isOlderThanFiveDays;
          
          const convertOutGroupCellData = buildCellData({
            cellType: 'convert_out',
            date: formattedDate,
            module: 'prepack-inout',
            productGroupId: productGroupId,
            finishedProductId: finish_pid ,
            productGroupName: salesColumn.data.productGroupId,
            rawProductIds: groupProductIds,
          });
          const hasRemarksConvertOutGroup = cellHasRemarks(convertOutGroupCellData, cellRemarks);

           if (isTypeC) {
              
              return (
                <td  tabIndex={0}
                  className={`arrival-bg fw-bold arival-qty-ui convert-out-column remark-enabled-cell ${hasRemarksConvertOutGroup ? 'cell-with-remark' : ''} ${selectedCell.row === rowIndex || selectedCell.col === thisCol ? "highlight-border" : ""} ${isOutsideSpecialPeriod ? 'disabled-cell' : ''}`}
                  onFocus={() => {
                    setSelectedCell({ row: rowIndex, col: thisCol });
                  }}
                  onClick={() => {
                    if (!checkEditPermission(rolesData?.permissions, 'prepack_in_out')) {
                      return;
                    }
                    if (isOutsideSpecialRange) {
                      toast.warning('This date is outside of the special period for this product');
                      return;
                    }
                    if (isOlderThanFiveDays) {
                      toast.warning('This date is more than 5 days ago and cannot be edited');
                      return;
                    }
                    setGroupProductIds(reserveUpdateProductIds);
                    setModalConvertOut(true);
                    setSelectedManualConvertOutRawProductId(groupProductIds);
                    setSelectedManualConvertOutFinishedProductId(finish_pid);
                    setSelectedManualConvertOutDate(formattedDate);
                  }}
                  onContextMenu={(e) => {
                    handleCellContextMenu(e, convertOutGroupCellData, setContextMenu, setSelectedCellData);
                  }}
                  {...getCellDataAttributes(convertOutGroupCellData)}
                  style={{ cursor: isOutsideSpecialPeriod ? 'not-allowed' : 'pointer' }}
                >
                  <span className="ml-1">{displayConvertOutQuantity !== '' ? displayConvertOutQuantity : ''}</span>
                </td>
              );
          }
          return (
            <td 
              onClick={() => setSelectedCell({ row: rowIndex, col: thisCol })} 
              onContextMenu={(e) => {
                handleCellContextMenu(e, convertOutGroupCellData, setContextMenu, setSelectedCellData);
              }}
              {...getCellDataAttributes(convertOutGroupCellData)}
              className={`arrival-bg fw-bold arival-qty-ui convert-out-column remark-enabled-cell ${hasRemarksConvertOutGroup ? 'cell-with-remark' : ''} ${selectedCell.row === rowIndex || selectedCell.col === thisCol ? "highlight-border" : ""}`}
            >
              <span className="ml-1">{convertOutQuantity !== '' ? convertOutQuantity : ''}</span>
            </td>
          );
        })()})}
        
          {/* //total quantity block */}
        {(() => {
          const thisCol = columnCounter.value++;
          const key = `${rowIndex}-${thisCol}`;
          const isSelected = selectedCellsForSum[key] !== undefined;

          let totalQuantity = 0;
          Object.values(customerGroups).forEach(subGroupObject =>
            Object.values(subGroupObject).forEach(datesObject =>
              (datesObject[nextDate] || []).forEach(item => {
                totalQuantity += Number(item.quantity) || 0;
              })
            )
          );
          if(salesColumn?.data?.prepackProductType == 0 || salesColumn?.data?.prepackProductType == 2){
            totalQuantity+=Number(totalConvertOutQuantity) || 0;
          }
           

          const handleClick = () => {
            const newSelection = getUpdatedSelection(
              selectedCellsForSum,
              rowIndex,
              thisCol,
              totalQuantity
            );
            setSelectedCellsForSum(newSelection);
            setSelectedCell({ row: rowIndex, col: thisCol });
          };

          const totalQtyGroupCellData = buildCellData({
            cellType: 'total_qty',
            date: formattedDate,
            module: 'prepack-inout',
            productGroupId: productGroupId,
            finishedProductId:(salesColumn.data?.prepackProductType == 0 || salesColumn.data?.prepackProductType == 2) ? firstFinishProductId : groupProductIds[0],
            productGroupName: salesColumn.data.productGroupId,
          });
          const hasRemarksTotalQtyGroup = cellHasRemarks(totalQtyGroupCellData, cellRemarks);

          return (
            <td
              onClick={handleClick}
              onContextMenu={(e) => {
                handleCellContextMenu(e, totalQtyGroupCellData, setContextMenu, setSelectedCellData);
              }}
              {...getCellDataAttributes(totalQtyGroupCellData)}
              className={`sales-bg remark-enabled-cell ${hasRemarksTotalQtyGroup ? 'cell-with-remark' : ''} ${totalQuantity !== undefined ? 'show-sum-checkbox' : ''} ${selectedCell.row === rowIndex || selectedCell.col === thisCol ? "highlight-border" : ""}`}
            >
              <div className="flex">
                {totalQuantity !== undefined && <div className="grouping">
                  <label className="checbox-cs relative cursor-pointer">
                    <input
                      type="checkbox"
                      checked={isSelected}
                      onChange={(e) => {
                        e.stopPropagation();
                        handleClick();
                      }}
                      className="cursor-pointer absolute opacity-0 w-0 h-0"
                    />
                    <span className="checkmark" onClick={(e) => e.stopPropagation()}></span>
                  </label>{" "}
                  <span className="ml-1">{totalQuantity}</span>
                </div>}
              </div>
            </td>
          );
        })()}

        {(() => {
          const thisCol = columnCounter.value++;
          const shouldShowEstimate = estimatedStock !== null && estimatedStock !== undefined;
          const isForComparison = inventoryForDate?.estimated_for_comparison;
          
          const estimateStockGroupCellData = buildCellData({
            cellType: 'estimate_stock',
            date: nextDate,
            module: 'prepack-inout',
            productGroupId: productGroupId,
            finishedProductId: (salesColumn.data?.prepackProductType == 0 || salesColumn.data?.prepackProductType == 2) ? firstFinishProductId : groupProductIds[0],
            productGroupName: salesColumn.data.productGroupId,
          });
          const hasRemarksEstimateStockGroup = cellHasRemarks(estimateStockGroupCellData, cellRemarks);
          
          return (
            <td 
              onClick={() => setSelectedCell({ row: rowIndex, col: thisCol })} 
              onContextMenu={(e) => {
                handleCellContextMenu(e, estimateStockGroupCellData, setContextMenu, setSelectedCellData);
              }}
              {...getCellDataAttributes(estimateStockGroupCellData)}
              className={`estimate-stock remark-enabled-cell ${hasRemarksEstimateStockGroup ? 'cell-with-remark' : ''} ${selectedCell.row === rowIndex || selectedCell.col === thisCol ? "highlight-border" : ""}`}
              style={isForComparison ? { color: '#6c757d' } : {}}
            >
              {shouldShowEstimate && estimatedStock}
            </td>
          );
        })()}
        {(() => {
          const thisCol = columnCounter.value++;
          return (
            <td
              onClick={() => setSelectedCell({ row: rowIndex, col: thisCol })}
              className={`stock-bg actual-stock ${(showGroupData != null) ? showGroupData !== productGroupId ? 'not-check' : '' : 'not-check'} ${selectedCell.row === rowIndex || selectedCell.col === thisCol ? "highlight-border" : ""}`}
            >
              {(inventoryStatus === 'mixed' || inventoryStatus === 'actual') ? actualStock : (nextDate > format(new Date(), 'yyyy-MM-dd') ? '' : 'No Record')}
            </td>
          );
        })()}
        {showGroupData === productGroupId && (
          <>
            {selectedGroupProducts[productGroupId]?.products && (
              <>
                {[...new Map(
                  selectedGroupProducts[productGroupId].products?.products.map(p => [p.id, p])
                ).values()].map((uniqueProduct, index, arr) => {
                  const matchedProduct = selectedGroupProducts[productGroupId].products.data.find(
                    p => p.key === uniqueProduct.id && p.date === nextDate
                  );
                  return (
                    (() => {
                      const thisCol = columnCounter.value++;
                      const canEditSub = onEditActualStock && nextDate <= format(new Date(), 'yyyy-MM-dd');
                      return (
                        <td
                          key={`stock-${productGroupId}-${uniqueProduct.id}-${index}`}
                          className={`stock-bg ${index === arr.length - 1 ? 'not-check' : ''} ${selectedCell.row === rowIndex || selectedCell.col === thisCol ? "highlight-border" : ""}`}
                          style={canEditSub ? { cursor: 'pointer' } : {}}
                          onClick={() => {
                            setSelectedCell({ row: rowIndex, col: thisCol });
                            if (canEditSub) {
                              onEditActualStock({
                                actual_stock: matchedProduct?.actual_stock ?? '',
                                date: nextDate,
                                product_id: uniqueProduct.id,
                                refreshIds: reserveUpdateProductIds,
                              });
                            }
                          }}
                        >
                          {matchedProduct?.actual_stock ?? ''}
                        </td>
                      );
                    })()
                  );
                })}
              </>
            )}
          </>
        )}
      </React.Fragment>
    </>
  );
};
